<template>
  <div>
    <el-table :data="qutaForm.assemblyPartsList" border class="el-table-two" @selection-change="handleSelectionPart">
      <el-table-column align="center" label="序号" width="60">
        <template v-slot="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="配件名称">
        <template v-slot="scope">
          <el-form-item :prop="'factoryList.' + formIndex + '.assemblyPartsList.' + scope.$index + '.quta_part_name'" label-width="0">
            <el-input v-model="scope.row.quta_part_name" maxlength="30" placeholder="暂无配件名称" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="配件规格">
        <template v-slot="scope">
          <el-form-item :prop="'factoryList.' + formIndex + '.assemblyPartsList.' + scope.$index + '.quta_part_spec'" label-width="0">
            <el-input v-model="scope.row.quta_part_spec" maxlength="255" placeholder="暂无配件规格" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="配件价格">
        <template v-slot="scope">
          <el-form-item :prop="'factoryList.' + formIndex + '.assemblyPartsList.' + scope.$index + '.quta_part_price'" label-width="0">
            <el-input
              v-model="scope.row.quta_part_price"
              maxlength="13"
              placeholder="暂无配件价格"
              show-word-limit
              @blur="scope.row.quta_part_price = helper.calcPrice(scope.row.quta_part_price, 4, 100000000)"
              @change="getTotalPrice"
              @input="scope.row.quta_part_price = helper.keepTNum1(scope.row.quta_part_price)"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="配件重量">
        <template v-slot="scope">
          <el-form-item :prop="'factoryList.' + formIndex + '.assemblyPartsList.' + scope.$index + '.quta_part_weight'" label-width="0">
            <el-input
              v-model="scope.row.quta_part_weight"
              maxlength="13"
              placeholder="暂无配件重量"
              show-word-limit
              @blur="scope.row.quta_part_weight = helper.calcPrice(scope.row.quta_part_weight, 4, 100000000)"
              @input="scope.row.quta_part_weight = helper.keepTNum1(scope.row.quta_part_weight)"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
    <div class="vd_price_toatl">
      <div class="vd_price">
        <h3><span>总计:</span></h3>
        <h2 class="vg_ml_8" style="color: #c70e0e">
          <span>{{ totalPrice }}</span>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';

export default {
  name: 'QutaPartList',
  props: {
    qutaForm: {
      type: Object,
      required: true
    },
    formIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      selectionsList: [],
      mtrlTypeGroupOpt: [],
      flag: true,
      totalPrice: ''
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {},
    //prcs清单选择框
    handleSelectionPart(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
      this.$emit('handleSelectionPart', this.selectionsList);
    },
    getTotalPrice() {
      let num = new BigNumber(0);
      if (this.qutaForm.assemblyPartsList) {
        this.qutaForm.assemblyPartsList.forEach(item => {
          let num1 = new BigNumber(0);
          num1 = num1.plus(Number(item.quta_part_price) ? Number(item.quta_part_price) : 0);
          num = num.plus(num1);
        });
      }
      num = num.toNumber();
      this.totalPrice = this.helper.haveFour(num, 4);
    }
  }
};
</script>

<style lang="scss">
.vd_dis {
  display: inline-block;
}

.vd_mrl {
  margin-left: 5px;
}

.vd_wid100 {
  width: 100%;
}

.el-input-group__prepend {
  font-size: 16px;
  color: #000000;
}

.vd_price_toatl {
  /* display: flex;
  justify-content: space-between; */
  padding: 10px 20px;
}

.vd_price {
  display: flex;
  justify-content: flex-end;
}
</style>
